import { Flex } from '@utilitywarehouse/hearth-react';

import { useAppointmentContext } from '@providers/AppointmentProvider/AppointmentContext';

import { PreJoinInfo } from './PreJoinInfo';
import { PreJoinSteps } from './PreJoinSteps';

const PreJoin = () => {
  const { session, appointment } = useAppointmentContext();

  const handleStart = () => {
    // join appointment and navigate to the lobby
  };

  if (!session || !appointment || !session?.userType || !session?.userId) {
    return null;
  }

  return (
    <div className="wrapper">
      <Flex direction="column" spacing="2xl">
        <PreJoinInfo appointment={appointment} userId={session.userId} />

        <PreJoinSteps userType={session.userType} onStart={handleStart} />
      </Flex>
    </div>
  );
};

export { PreJoin };
